import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";

const AddCategoryModal = ({ show, handleClose, mode = "create", data }) => {
  const { AsyncPostApiCall, AsyncPutApiCall } = useApi();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  // Reset form values when modal opens/closes
  useEffect(() => {
    if (mode === "edit" && data) {
      setName(data?.name || "");
    } else {
      setName("");
    }
  }, [data, mode, show]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.error("Category name is required");
      return;
    }

    try {
      setLoading(true);
      let result;

      if (mode === "create") {
        result = await AsyncPostApiCall("/category/create", { name });
      } else {
        result = await AsyncPutApiCall(`/category/update/${data?._id}`, {
          name,
        });
      }

      if (result?.success) {
        toast.success(
          result?.message ||
            (mode === "create"
              ? "Category created successfully"
              : "Category updated successfully")
        );
        handleClose(true);
      } else {
        toast.error(
          result?.message ||
            (mode === "create"
              ? "Failed to create category"
              : "Failed to update category")
        );
      }
    } catch (error) {
      console.error("Error saving category:", error);
      toast.error("Something went wrong while saving category");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={() => handleClose(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {mode === "create" ? "Create Category" : "Edit Category"}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Category Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter category name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={loading}
              maxLength={30}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => handleClose(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddCategoryModal;
